document.addEventListener('DOMContentLoaded', function() {
  let previousTrigger = null;

  function updateImagesIfExpanded(trigger) {
      if (trigger === previousTrigger) return; 
      previousTrigger = trigger;

      const accordionParent = trigger.closest('.accordion');
      const accordionOverallParent = trigger.closest('.split-screen-hero');
      if (accordionParent && accordionOverallParent) {
          const desktopImage = accordionParent.getAttribute('data-desktop-image');
          const mobileImage = accordionParent.getAttribute('data-mobile-image');

          const defaultDesktopImage = accordionOverallParent.querySelector('.split-screen-hero__image-wrapper').getAttribute('data-default-desk-image');
          const defaultMobileImage = accordionOverallParent.querySelector('.split-screen-hero__image-wrapper').getAttribute('data-default-mob-image');

          let desktopImageElement = accordionOverallParent.querySelector('.split-screen-hero__image.d-only');
          let mobileImageElement = accordionOverallParent.querySelector('.split-screen-hero__image.m-only');

          // Use default images if desktopImageElement or mobileImageElement is missing
          if (!desktopImageElement && defaultDesktopImage) {
              desktopImageElement = document.createElement('img');
              desktopImageElement.classList.add('split-screen-hero__image', 'd-only');
              accordionOverallParent.appendChild(desktopImageElement);
          }
          if (!mobileImageElement && defaultMobileImage) {
              mobileImageElement = document.createElement('img');
              mobileImageElement.classList.add('split-screen-hero__image', 'm-only');
              accordionOverallParent.appendChild(mobileImageElement);
          }

          // Update image attributes with fading effect
          if (desktopImageElement && mobileImageElement) {
              fadeOut(desktopImageElement);
              fadeOut(mobileImageElement);

              setTimeout(() => {
                  updateImageAttributes(desktopImageElement, desktopImage || defaultDesktopImage);
                  updateImageAttributes(mobileImageElement, mobileImage || defaultMobileImage);
                  fadeIn(desktopImageElement);
                  fadeIn(mobileImageElement);
              }, 500); // Delay to ensure fading out finishes before fading in
          }
      }
  }

  function fadeOut(element) {
      element.style.opacity = '0';
  }

  function fadeIn(element) {
      element.style.opacity = '1';
  }

  // Function to update all attributes of an image element
  function updateImageAttributes(imageElement, newImageUrl) {
      if (imageElement) {
          imageElement.src = newImageUrl;
          imageElement.srcset = newImageUrl;
      }
  }

  const accordionTriggers = document.querySelectorAll('.accordion .js-accordion-trigger');
  accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
          updateImagesIfExpanded(this);
      });
  });
});